import { CustomEpic } from 'types/types';
import {
  FetchLeadActionPayload,
  fetchLeadFailure,
  fetchLeadSuccess,
} from 'modules/leads/actions';
import { ofType } from 'redux-observable';
import { FETCH_LEAD_START } from 'modules/leads/actionTypes';
import { switchMap } from 'rxjs/operators';
import { getFetchLeadUrl } from 'modules/leads/utils/getFetchLeadUrl';
import { getAuthHeaders } from 'api/getAuthHeaders';
import { handleAjaxSuccess } from 'utils/epics/handleAjaxSuccess';
import { translateFetchLead } from 'modules/leads/translateFetchLead';
import { handleAjaxError } from 'utils/epics/handleAjaxError';

export const fetchLead$: CustomEpic<FetchLeadActionPayload> = (
  action$,
  state$,
  { getApi$ },
) =>
  action$.pipe(
    ofType(FETCH_LEAD_START),
    switchMap(({ payload: { leadId } }) =>
      getApi$({
        endpoint: getFetchLeadUrl({ leadId }),
        headers: getAuthHeaders(state$.value),
      }).pipe(
        handleAjaxSuccess(fetchLeadSuccess, translateFetchLead),
        handleAjaxError(fetchLeadFailure),
      ),
    ),
  );
